import { PageCourseGallerySchema } from "@/sanity/pages/PageCourseGalleryTemplate";
import Header from "../global/partials/Header";
import HeroSection from "../global/sections/courseGallery/HeroSection";
import StatsSection from "../global/sections/courseGallery/StatsSection";
import MasterClassSection from "../global/sections/courseGallery/MasterClassSection";
import MentorsSection from "../global/sections/home/MentorsSection";
import DisciplinesSection from "../global/sections/courseGallery/DisciplinesSection";
import AllClassesSection from "../global/sections/courseGallery/AllClassesSection";
import FaqSection from "../global/sections/home/FaqSection";
import FooterSection from "../global/sections/home/FooterSection";

// Course Gallery page — Figma "Course Page" → Gallery / Course (3780:19178).
// The FAQ and footer bands are identical to Home's, so those sections are
// reused rather than duplicated.
export default function PageCourseGalleryJSX({
  data,
}: {
  data: PageCourseGallerySchema;
}) {
  return (
    <main id="top" className="overflow-clip bg-black">
      <Header data={data.settings.header} variant="slim" />

      <HeroSection
        chip={data?.heroChip}
        title={data?.heroTitle}
        subtitle={data?.heroSubtitle}
        cta={data?.heroCTA}
        cards={data?.heroCards}
      />

      <StatsSection
        chip={data?.statsChip}
        title={data?.statsTitle}
        items={data?.statsItems}
      />

      <MasterClassSection
        chip={data?.masterClassChip}
        title={data?.masterClassTitle}
        body={data?.masterClassBody}
        cta={data?.masterClassCTA}
        cards={data?.masterClassCards}
      />

      <div id="mentors" className="scroll-mt-[10rem]">
        <MentorsSection
          variant="courseGallery"
          chip={data?.mentorsChip}
          title={data?.mentorsTitle}
          mentors={data?.mentors}
        />
      </div>

      <div id="disciplines" className="scroll-mt-[10rem]">
        <DisciplinesSection
          chip={data?.disciplinesChip}
          title={data?.disciplinesTitle}
          subtitle={data?.disciplinesSubtitle}
          disciplines={data?.disciplines}
        />
      </div>

      <div id="classes" className="scroll-mt-[10rem]">
        <AllClassesSection
          title={data?.classesTitle}
          filterLabel={data?.classesFilterLabel}
          classes={data?.classes}
        />
      </div>

      <div id="faq" className="scroll-mt-[10rem]">
        <FaqSection
          chip={data?.faqChip}
          title={data?.faqTitle}
          items={data?.faqItems}
        />
      </div>

      <FooterSection
        logo={data?.footerLogo}
        headline={data?.footerHeadline}
        subtext={data?.footerSubtext}
        cta={data?.footerCTA}
        columns={data?.footerColumns}
        copyright={data?.footerCopyright}
        legalLinks={data?.footerLegalLinks}
      />
    </main>
  );
}
